// Badge catalog matching the existing Joy backend badge behavior.
export const BADGES = [
  { id: "first_lesson", emoji: "🌟", name: "Primeira Lição", desc: "Complete 1 lição", cond: (p) => (p.completed_lessons?.length || 0) >= 1 },
  { id: "three_lessons", emoji: "📚", name: "Estudante Dedicado", desc: "Complete 3 lições", cond: (p) => (p.completed_lessons?.length || 0) >= 3 },
  { id: "six_lessons", emoji: "🎓", name: "Aprendiz Avançado", desc: "Complete 6 lições", cond: (p) => (p.completed_lessons?.length || 0) >= 6 },
  { id: "all_lessons", emoji: "🏆", name: "Mestre do Inglês", desc: "Complete todas as 15 lições", cond: (p) => (p.completed_lessons?.length || 0) >= 15 },
  { id: "xp_100", emoji: "⭐", name: "Coletor de XP", desc: "Alcance 100 XP", cond: (p) => (p.total_xp || 0) >= 100 },
  { id: "xp_500", emoji: "💫", name: "Estrela de Ouro", desc: "Alcance 500 XP", cond: (p) => (p.total_xp || 0) >= 500 },
];

export function isBadgeUnlocked(badge, progress) {
  if (!progress) return false;
  const inList = (progress.badges || []).includes(badge.id);
  return inList || badge.cond(progress);
}

// Level ~ every 100 XP. Backend returns current_level; these helpers derive per-level progress.
export function levelInfo(progress) {
  const level = progress?.current_level || 1;
  const xp = progress?.total_xp || 0;
  const floor = (level - 1) * 100;
  const inLevel = Math.max(0, xp - floor);
  const percent = Math.min(100, Math.round((inLevel / 100) * 100));
  return { level, xp, inLevel, needed: 100, percent, nextAt: level * 100 };
}
